module.exports = __webpack_public_path__ + "static/media/VEDL_F1.dc4b7cc5.txt";